import React, { useEffect } from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import NewPasswordContent from "./NewPasswordContent";
import NewPasswordButtons from "./widget/NewPasswordButtons";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import { NewPasswordContextProvider } from "../../../../provider/onboarding/forgot_password/new_password/NewPasswordContextProvider";
import AppConfigService from "../../../../service/app_config/AppConfigService";

const NewPasswordScreen = () => {
  const type: number = ResponsiveDeviceType();

  const checkRecoverSession = () => {
    const recoverSession = SessionStorage.getValue(
      StorageKeys.recover_password_detail
    );
    if (UtilityHelper.isEmpty(recoverSession)) {
      navigate(appRoutes.routeNameLogin, { replace: true });
    }
  };

  useEffect(() => {
    checkRecoverSession();
  }, []);

  return (
    <NewPasswordContextProvider>
      <Scaffold
        appBarTitle={
          type === 3 ? undefined : AppConfigService.get("company_name")
        }
        bottomNavigationButton={<NewPasswordButtons />}
      >
        <MainBodyContainer className={type !== 3 ? "pt-5" : ""}>
          <NewPasswordContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </NewPasswordContextProvider>
  );
};

export default NewPasswordScreen;
export const routeName: string = "/new-password";
